/**
 * Featured Product Spotlight runtime.
 *
 * Loaded only when `cta_action: add_to_cart` — the view-product preset is a
 * pure anchor and ships no JS. Responsibilities:
 *   1. Bind the single call-to-action button.
 *   2. On click — quick-add the SSR-resolved default variant × 1 via
 *      window.Spectrum.cart, opening the theme's cart UI. The variant id and
 *      availability are fully known at SSR (this block has no variant picker),
 *      so there is no client-side price/variant recompute.
 *
 * Theme-agnostic — depends only on window.Spectrum.cart.
 */
;(() => {
  const SNIPPET_ID = 'cyg4u4ji'
  const FEATURE_SLUG = 'featured_spotlight'

  function noopTrack() {}
  function safeTrack(track) {
    if (typeof track !== 'function') return noopTrack
    return (eventName, payload) => {
      try {
        track(eventName, payload)
      } catch (err) {
        console.warn(`[${FEATURE_SLUG}] analytics dispatch failed`, err)
      }
    }
  }

  class SaiSpotlightElement extends HTMLElement {
    connectedCallback() {
      if (this._mounted) return
      this._mounted = true

      const btn = this.querySelector('[data-spectrum-atc]')
      if (!btn) return
      this._btn = btn
      this._track = noopTrack

      const snippetApi = window.__spectrumAi && window.__spectrumAi.snippet
      if (snippetApi && typeof snippetApi.bind === 'function') {
        const handles = snippetApi.bind(this, () => {})
        if (handles && handles.track) this._track = safeTrack(handles.track)
      }

      btn.addEventListener('click', () => this._addToCart())
    }

    disconnectedCallback() {
      // Cart drawers move/re-render nodes; allow a re-inserted element to re-bind.
      this._mounted = false
    }

    async _addToCart() {
      const btn = this._btn
      const variantId = btn && btn.dataset.variantId
      if (!variantId || btn.disabled) return
      const cart = window.Spectrum && window.Spectrum.cart
      if (!cart || typeof cart.add !== 'function') {
        console.warn(`[${FEATURE_SLUG}] window.Spectrum.cart unavailable — cannot add to cart`)
        return
      }

      const item = { id: variantId, quantity: 1 }
      this._setLoading(btn, true)
      this._track(`${FEATURE_SLUG}:add_to_cart`, {
        product_id: this.dataset.productId,
        variant_id: variantId,
        quantity: 1,
      })

      try {
        if (typeof cart.addAndOpen === 'function') {
          await cart.addAndOpen(item, { sourceId: `spectrum-${SNIPPET_ID}` })
        } else {
          await cart.add(item, { sourceId: `spectrum-${SNIPPET_ID}` })
        }
        this._setLoading(btn, false)
      } catch (err) {
        console.warn(`[${FEATURE_SLUG}] add to cart failed`, err)
        this._setLoading(btn, false)
      }
    }

    _setLoading(btn, loading) {
      if (!btn) return
      btn.disabled = loading
      const spinner = btn.querySelector('[data-spectrum-spinner]')
      if (spinner) {
        spinner.hidden = !loading
        btn.setAttribute('aria-busy', loading ? 'true' : 'false')
      }
    }
  }

  if (!customElements.get('sai-cyg4u4ji')) {
    customElements.define('sai-cyg4u4ji', SaiSpotlightElement)
  }
})()
